export const environment = {
  production: true,
  apiUrl: 'https://sky-dap-prod-finance-fa-cognos.azurewebsites.net/api', /*Function app Api URL*/
  functionKey: 'Klz5O6X6TZWqjtYtfj_CZrW9Jtibvd3PNmsySu72R9PSAzFu7PzH2Q==',
  appUrl: 'https://cognos-controller-archive.middleware.sky' /*Angular Web app URL*/
};
